export function smlTokenAddr(address) {
    if (!address) {
        return '';
    }
    const length = address.length;
    const visibleCharacters = Math.min(length, 4);
    return address.slice(0, 3) + '...' + address.slice(length - visibleCharacters, length);
}
